import Avatar from '@jobseeker/lotus/components/Avatar';
import {Box} from '@jobseeker/lotus/foundations';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import {Image} from '@jobseeker/lotus/components/Image';

import {/*DrawerClose,*/ Edit, Logout} from '@jobseeker/lotus/icons';
import {getOldLink, getProLink, truncateString} from '@jobseeker/lotus/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';
import Pro from '@jobseeker/lotus/elements/Pro';
import ProgressBar from '@jobseeker/lotus/elements/ProgressBar';
import {ButtonV2} from '@jobseeker/lotus/elements';

import type {ProfileDrawerOption, ProfileDrawerProps} from './types';

const ProfileDrawer = ({
  theme,
  handleDrawer,
  openDrawer,
  name,
  email,
  phoneVerified,
  profileProgress,
  profilePicUrl,
  proMembership,
  page,
  OnLogoutBtnClick,
  profileDrawerOptions,
  followUps,
  aboutSection,
  proMeta,
  reCap,
  savedJobCount,
}: ProfileDrawerProps) => {
  const listData = profileDrawerOptions.slice(0, 7);

  const listData1 = profileDrawerOptions.slice(7, profileDrawerOptions.length);

  const LinkItem = ({
    option,
    index,
  }: {
    option: ProfileDrawerOption;
    index: number;
  }) => (
    <ListItem
      component="a"
      key={`profiledrawer-list-item-${index}`}
      title={option['label']}
      href={getOldLink(option['url'])}
      target="_blank"
      sx={{
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        whiteSpace: 'wrap',
        cursor: 'pointer',
        color: theme.palette.secondary.main,
        wordBreak: 'break-word',
        ':hover': {
          color: theme.palette.secondary.main,
          textDecoration: 'underline',
          textDecorationSkipInk: 'none',
        },
        paddingLeft: 0,
      }}
    >
      {option['label']}
    </ListItem>
  );
  return (
    <Drawer
      anchor="right"
      open={openDrawer}
      onClose={() => {
        handleDrawer(false);
      }}
      PaperProps={{
        sx: {
          padding: '24px 16px',
          borderRadius: '10px 0 0 10px',
          boxSizing: 'border-box',
          boxShadow: 2,
          maxWidth: theme.spacing(55),
        },
      }}
    >
      {/* <Image
        src={DrawerClose}
        alt={'ProfileDrawer'}
        width={18}
        height={18}
        objectFit="cover"
        quality={50}
      /> */}
      <Box width="100%">
        {email && (
          <Box
            display="flex"
            mb={theme.spacing(1)}
            borderRadius={theme.spacing(1)}
            sx={{
              '@media (width:320px)': {
                margin: theme.spacing(1),
              },
            }}
          >
            <Box my={theme.spacing(1)}>
              <Avatar
                imgUrl={profilePicUrl}
                showFallbackIcon={true}
                onClick={() => {
                  openUrl(
                    getOldLink(
                      '/registration/addPersonalDetails?ref=profiledrw'
                    ),
                    '_self'
                  );
                }}
                sx={{width: 60, height: 60}}
              />
            </Box>
            <Box
              display="block"
              mt={theme.spacing(1)}
              sx={{float: 'left', marginLeft: theme.spacing(1.375), width: 300}}
              pb={theme.spacing(1)}
            >
              <Typography
                fontWeight={600}
                component="span"
                fontSize={theme.typography.pxToRem(14)}
                overflow="hidden"
                whiteSpace="nowrap"
                display="flex"
                alignItems={'center'}
                color={theme.palette.secondary.main}
              >
                {truncateString(name, 26)}
                {proMembership?.isValid && (
                  <Box display="block" ml={theme.spacing(0.5)}>
                    <Pro bgColor="linear-gradient(180deg, #FFB743 0%, #F99914 100%)" />
                  </Box>
                )}
              </Typography>

              <Typography
                fontWeight={theme.typography.fontWeightMedium}
                component="span"
                fontSize={theme.typography.pxToRem(12)}
                display="block"
                color={theme.palette.secondary.main}
              >
                {email}
              </Typography>

              {!phoneVerified && (
                <Typography
                  fontWeight={theme.typography.fontWeightMedium}
                  component="a"
                  fontSize={theme.typography.pxToRem(12)}
                  display="block"
                  color={theme.palette.primary.main}
                  marginTop={theme.spacing(0.5)}
                  sx={{
                    cursor: 'pointer',
                    textDecoration: 'none',
                    color: theme.palette.primary.main,
                  }}
                  href={getOldLink('/settings?section=verify-contact-details')}
                >
                  {'Verify Phone Number'}
                </Typography>
              )}
            </Box>
            {email && (
              <Box py={theme.spacing(1.5)} marginRight={theme.spacing(1)}>
                <Image
                  src={Edit}
                  alt={'edit_profile'}
                  width={32}
                  height={32}
                  object-fit="cover"
                  onClick={event => {
                    event?.preventDefault();
                    openUrl(
                      getOldLink('/registration/addPersonalDetails'),
                      '_self'
                    );
                  }}
                  style={{
                    cursor: 'pointer',
                  }}
                />
              </Box>
            )}
          </Box>
        )}

        <Box>
          <ProgressBar
            value={profileProgress ? profileProgress : 0}
            barColor="#EDBB4A"
          />
        </Box>

        {!proMembership?.isValid && (
          <Box
            mt={theme.spacing(1)}
            p={theme.spacing(2)}
            sx={{
              background:
                'linear-gradient(243deg, rgba(215, 220, 210, 0.96) 0%, rgba(215, 220, 210, 0.96) 61%, rgba(233, 222, 197, 0.96) 87%, rgba(215, 195, 226, 0.96) 100%, rgba(255, 255, 255, 0) 100%)',
              overflow: 'hidden',
              borderRadius: theme.spacing(1),
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <Typography
              fontWeight={theme.typography.fontWeightMedium}
              fontSize={theme.typography.pxToRem(14)}
            >
              Enhance your
              <br />
              Job Search with PRO
            </Typography>
            <ButtonV2
              sx={{
                background: theme.palette.pro.main,
                py: 1,
                px: 3,
                height: theme.spacing(4),
                fontSize: theme.typography.pxToRem(12),
              }}
              variant="contained"
              size="small"
              href={getProLink(
                page || 'jf',
                reCap?.toString(),
                proMeta?.refCode
              )}
              target="_self"
            >
              Upgrade to PRO
            </ButtonV2>
          </Box>
        )}

        {email && profileDrawerOptions?.length > 0 && (
          <Box my={1}>
            <Box
              display="block"
              borderRadius={theme.spacing(2)}
              border={`1px rgba(126, 126, 126, 0.20) solid`}
            >
              <Typography
                fontSize={theme.typography.pxToRem(16)}
                fontWeight={theme.typography.fontWeightMedium}
                mx={theme.spacing(2)}
                marginTop={theme.spacing(2)}
                marginBottom={theme.spacing(0)}
              >
                {'Account Details'}
              </Typography>
              <Box display="flex" flex="0 0 auto">
                <List
                  sx={{
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(5),
                  }}
                >
                  {listData?.map((option, index) => {
                    const savedCount =
                      option['label'] === 'Saved Jobs' &&
                      typeof savedJobCount === 'number' &&
                      savedJobCount > 0
                        ? `${option['label']} (${savedJobCount})`
                        : option['label'];

                    return (
                      <LinkItem
                        option={{...option, label: savedCount}}
                        index={index}
                        key={index}
                      />
                    );
                  })}
                </List>
                <List
                  sx={{
                    float: 'right',
                  }}
                >
                  {listData1?.map((option, index) => {
                    const sx = {
                      fontSize: theme.typography.pxToRem(14),
                      fontWeight: theme.typography.fontWeightRegular,
                      whiteSpace: 'wrap',
                      cursor:
                        option['label'] === 'Follow Up' &&
                        proMembership?.isValid
                          ? 'text'
                          : 'pointer',
                      color: theme.palette.secondary.main,
                      wordBreak: 'break-word',
                      ':hover': {
                        color: theme.palette.secondary.main,
                        textDecoration:
                          option['label'] === 'Follow Up' &&
                          proMembership?.isValid
                            ? 'none'
                            : 'underline',
                      },
                      paddingLeft: 0,
                    };

                    const isProFollowUp =
                      option['label'] === 'Follow Up' &&
                      typeof followUps === 'number' &&
                      followUps > 0;

                    if (isProFollowUp && proMembership?.isValid) {
                      return (
                        <Typography
                          component={'h2'}
                          sx={{...sx, paddingY: 1, paddingRight: 2}}
                        >
                          {`${option['label']} (${followUps})`}
                        </Typography>
                      );
                    }

                    return (
                      <ListItem
                        component="a"
                        key={`profiledrawer-data-list-item-${index}`}
                        title={option['label']}
                        href={getOldLink(option['url'])}
                        target="_self"
                        sx={sx}
                      >
                        {option['label']}
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </Box>
          </Box>
        )}
        <Box
          display="flex"
          borderRadius={theme.spacing(2)}
          my={1}
          border={`1px rgba(126, 126, 126, 0.20) solid`}
        >
          <Link
            href={process.env.NEXT_PUBLIC_LEARNING_CENTER}
            target="_blank"
            marginLeft={theme.spacing(2)}
            color="secondary.main"
            fontWeight={theme.typography.fontWeightMedium}
            lineHeight={2.5}
            sx={{
              textDecoration: 'none',
            }}
          >
            {'My Learning Center'}
          </Link>
        </Box>
        {email && (
          <>
            <Box
              display="flex"
              borderRadius={theme.spacing(2)}
              my={1}
              border={`1px rgba(126, 126, 126, 0.20) solid`}
            >
              <Link
                href={getOldLink('/settings')}
                target="_blank"
                marginLeft={theme.spacing(2)}
                color="secondary.main"
                fontWeight={theme.typography.fontWeightMedium}
                lineHeight={2.5}
                sx={{
                  textDecoration: 'none',
                }}
              >
                {'My Settings'}
              </Link>
            </Box>
            <Box
              display="flex"
              borderRadius={theme.spacing(2)}
              my={1}
              border={`1px rgba(126, 126, 126, 0.20) solid`}
            >
              <Link
                // href={getOldLink('/registration/changepassword.php')}
                href={'/settings?section=account-settings'}
                target="_blank"
                marginLeft={theme.spacing(2)}
                color="secondary.main"
                fontWeight={theme.typography.fontWeightMedium}
                lineHeight={2.5}
                sx={{
                  textDecoration: 'none',
                }}
              >
                {'Change Password'}
              </Link>
            </Box>
          </>
        )}
        {aboutSection?.length > 0 && (
          <Box my={1}>
            <Box
              display="block"
              borderRadius={theme.spacing(2)}
              border={`1px rgba(126, 126, 126, 0.20) solid`}
            >
              <Typography
                fontSize={theme.typography.pxToRem(16)}
                fontWeight={theme.typography.fontWeightMedium}
                mx={theme.spacing(2)}
                marginTop={theme.spacing(2)}
                marginBottom={theme.spacing(0)}
              >
                {'About'}
              </Typography>

              <List
                sx={{
                  paddingLeft: theme.spacing(3.5),
                  paddingBottom: theme.spacing(2),
                }}
              >
                {aboutSection?.map(
                  (item, index) =>
                    item?.label &&
                    item?.label !== 'Recruiters Login' && (
                      <ListItem
                        component="a"
                        key={`lotus-profiledrawer-${index}`}
                        title={item['label']}
                        href={`${item?.link}`}
                        target="_blank"
                        sx={{
                          display: 'list-item',
                          listStyleType: 'disc',
                          fontSize: theme.typography.pxToRem(14),
                          fontWeight: theme.typography.fontWeightRegular,
                          whiteSpace: 'wrap',
                          cursor: 'pointer',
                          color: theme.palette.secondary.main,
                          wordBreak: 'break-word',
                          ':hover': {
                            color: theme.palette.secondary.main,
                            textDecoration: 'underline',
                          },
                          paddingBottom: 0,
                          paddingLeft: 0,
                        }}
                      >
                        {item?.label}
                      </ListItem>
                    )
                )}
              </List>
            </Box>
          </Box>
        )}
        <Box
          display="flex"
          marginTop={theme.spacing(2)}
          position="sticky"
          sx={{backgroundColor: 'white'}}
        >
          <Link
            display="flex"
            sx={{
              textDecoration: 'none',
              cursor: 'pointer',
            }}
            onClick={() => {
              OnLogoutBtnClick();
            }}
          >
            <Image
              src={Logout}
              alt={'logout'}
              width={20}
              height={20}
              object-fit="cover"
              style={{
                cursor: 'pointer',
              }}
            />
            <Typography
              marginLeft={theme.spacing(1.5)}
              color="#d11124"
              fontSize={{xxs: 14}}
              fontWeight={theme.typography.fontWeightMedium}
            >
              {'Logout'}
            </Typography>
          </Link>
        </Box>
        <Divider
          orientation="horizontal"
          sx={{
            marginTop: theme.spacing(2),
            border: '0.5px solid #ddd !important',
          }}
        />
        <Box marginTop={theme.spacing(2.5)}>
          <Link
            href="https://www.hirist.tech/"
            target="_blank"
            style={{cursor: 'pointer'}}
          >
            {'hirist.tech | IT Jobs'}
          </Link>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ProfileDrawer;
